import React from 'react';

const Modal = ({ show, onClose, title, des, src, githubLink }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
      <div className="bg-gray-900 rounded-lg overflow-hidden shadow-2xl w-11/12 md:w-2/3 lg:w-1/2 relative">
        <div className="flex justify-between items-center p-4 bg-gray-800 text-white rounded-t-lg">
          <h3 className="text-xl font-semibold">{title}</h3>
          <button onClick={onClose} className="text-white hover:text-red-500 text-2xl">&times;</button>
        </div>
        <img className="w-full h-64 object-cover" src={src} alt={title} />
        <div className="p-6 bg-gray-800">
          <h4 className="text-2xl font-bold mb-4 text-white">{title}</h4>
          <p className="text-gray-300 text-lg leading-relaxed text-justify">{des}</p>
        </div>
      </div>
    </div>
  );
};

export default Modal;
